import { useRef } from 'react';

import { useMajors } from '@modules/Majors/hooks/useMajors';

import { ArchetypeShareableCard } from '../components/ArchetypeShareableCard';
import { useShareImage } from './useShareImage';

interface UseArchetypeShareParams {
  archetype: string;
  archetypeDescription?: string | null;
}

export const useArchetypeShare = ({ archetype, archetypeDescription }: UseArchetypeShareParams) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const { share, isGenerating } = useShareImage(cardRef, {
    filename: 'my-academic-archetype.png',
    title: 'My Academic Archetype',
    text: 'Check out my Academic Archetype on beyondegrees.ai!',
  });

  const { majors } = useMajors({ limit: 3 });

  const topMajors = majors.map(major => ({
    title: major.title,
    matchValue: major.match.value,
  }));

  const hiddenCard = (
    <div
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
      }}
    >
      <ArchetypeShareableCard
        ref={cardRef}
        archetype={archetype}
        archetypeDescription={archetypeDescription}
        majors={topMajors}
      />
    </div>
  );

  return { share, isGenerating, hiddenCard };
};
